/**
 * Sort Favourites
 *
 * Sorts the leaderboard data, by adding the favourites to the front
 * of the data array
 *
 * @param {*} leaderboardArray - Input list of players
 * @param {*} favouritesArray - Array of a users favourite players
 * @returns {Array} An array of players, sorted by the leader then favourites
 */
export const sortFavourites = (leaderboardArray, favouritesArray) => {
    // Split favourites and remaining players into their own array
    const favouritePlayers = [];
    const remainingPlayers = leaderboardArray.filter((player) => {
        if (
            favouritesArray.some(
                (favourite) =>
                    favourite.providerId === player.player.playerId ||
                    favourite.providerId === player.player.providerId
            )
        ) {
            favouritePlayers.push(player);
            return false;
        }

        return true;
    });

    return [...favouritePlayers, ...remainingPlayers];
};
